
      export const versions = {
        commit: 'ab4b3159b05bcb2e289c838883aa5cb9c99a4725',
        branch: 'HEAD'
      };
